
import React from 'react'
import me from '../../assets/img/mypicturew.png'
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import teamMembers from '../../ProjectData';

const AllTeam = () => {
    return (
        <div className="pt-16 flex flex-col z-10 items-center justify-center w-full pb-28 rounded-t-3xl relative bottom-10">

            {/* Section Header */}
            <div className="flex flex-col items-center justify-center w-full py-3 gap-y-2">
                <h6 className="text-[26px] sm:text-[32px] md:text-[40px] font-bold">My Team</h6>
                <div className="section-line"></div>
                <p className="text-[16px] md:text-[20px] w-[97%] sm:w-[90%] md:w-[65%] lg:w-[55%] xl:w-[47%] text-center text-[#555555]">
                    Here, you will find information about each team member, their specialization, and their profiles.
                </p>
            </div>

            {/* Cards Container */}
            <div className='flex flex-col items-center justify-center w-full py-8 gap-y-20'>

                {/* My Card — Wide Hero Layout */}
                <div
                    className='relative w-[320px] sm:w-[480px] md:w-[580px] lg:w-[660px] rounded-[28px] overflow-hidden hover:-translate-y-2 transition-all duration-300'
                    style={{
                        backdropFilter: 'blur(24px)',
                        WebkitBackdropFilter: 'blur(24px)',
                        border: '1px solid rgba(255,255,255,0.6)',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.7)',
                    }}
                >

                    <div className='flex flex-col sm:flex-row items-center gap-6 p-7 sm:p-8 relative z-10'>
                        {/* Large Avatar */}
                        <div className='relative flex-shrink-0'>
                            <div className='absolute inset-0 rounded-full blur-2xl opacity-60'
                                style={{ background: 'conic-gradient(from 0deg, #818cf8, #34d399, #f472b6, #818cf8)' }} />
                            <div className='relative rounded-full p-[3px]'
                                style={{ background: 'linear-gradient(135deg, rgba(129,140,248,0.8), rgba(52,211,153,0.8), rgba(244,114,182,0.8))' }}
                            >
                                <img
                                    src={me}
                                    alt="Gulfam Haider"
                                    className='w-40 h-40 sm:w-48 sm:h-48 md:w-52 md:h-52 rounded-full object-cover'
                                    style={{ border: '3px solid rgba(255,255,255,0.8)' }}
                                />
                            </div>
                        </div>

                        {/* Info */}
                        <div className='flex flex-col items-center  text-center sm:text-left gap-y-3'>
                            <div>
                                <p className='text-xs uppercase tracking-[0.22em] font-semibold mb-1' style={{ color: '#818cf8' }}>Technical Lead</p>
                                <h1 className='text-3xl md:text-4xl font-bold tracking-tight' style={{ color: '#1e1b4b' }}>Gulfam Haider</h1>
                            </div>

                            <div className='flex items-center gap-2 px-3 py-1.5 rounded-full'
                                style={{ background: 'rgba(129,140,248,0.12)', border: '1px solid rgba(129,140,248,0.25)' }}>
                                <div className='w-1.5 h-1.5 rounded-full' style={{ background: '#818cf8' }} />
                                <p className='text-sm font-medium' style={{ color: '#4338ca' }}>Full Stack Engineer</p>
                            </div>

                            <div className='w-10 h-[1.5px] rounded-full' style={{ background: 'linear-gradient(90deg, #818cf8, #34d399)' }} />

                            <div className='flex items-center gap-x-3 mt-1'>
                                <a href="http://"
                                    className='flex items-center gap-2 px-4 py-2 rounded-xl font-medium text-sm hover:scale-105 transition-all duration-200'
                                    style={{ background: 'rgba(10,102,194,0.1)', border: '1px solid rgba(10,102,194,0.2)', color: '#0A66C2' }}>
                                    <FaLinkedin size={18} /> LinkedIn
                                </a>
                                <a href="http://"
                                    className='flex items-center gap-2 px-4 py-2 rounded-xl font-medium text-sm hover:scale-105 transition-all duration-200'
                                    style={{ background: 'rgba(30,27,75,0.07)', border: '1px solid rgba(30,27,75,0.15)', color: '#1e1b4b' }}>
                                    <FaGithub size={18} /> GitHub
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Team Cards */}
                <div className='grid w-[92%] xl:w-[95%] grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16 md:gap-y-20 place-items-center'>

                    {teamMembers.map((team) => (
                        <div
                            key={team.id}
                            className='relative w-[290px] sm:w-[300px] xl:w-[420px] rounded-[24px] overflow-visible pt-12 sm:pt-14 md:pt-16 hover:-translate-y-3 hover:scale-[1.02] transition-all duration-300 group'
                        >
                            {/* Card body */}
                            <div
                                className='relative rounded-[24px] overflow-hidden pt-16 sm:pt-20 pb-8 px-6'
                                style={{
                                    // background: 'linear-gradient(150deg, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.25) 100%)',
                                    backdropFilter: 'blur(20px)',
                                    WebkitBackdropFilter: 'blur(20px)',
                                    border: '1px solid rgba(255,255,255,0.55)',
                                    boxShadow: '0 2px 12px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.65)',
                                    minHeight: '300px',
                                }}
                            >

                                <div className='flex flex-col items-center justify-end text-center gap-y-2 relative z-10 pt-10 sm:pt-12'>
                                    <h1 className='text-xl font-bold tracking-tight' style={{ color: '#1e1b4b' }}>{team.name}</h1>

                                    <div className='flex items-center gap-1.5 px-3 py-1 rounded-full'
                                        style={{ background: 'rgba(129,140,248,0.1)', border: '1px solid rgba(129,140,248,0.2)' }}>
                                        <p className='text-[16px] font-semibold'>{team.info}</p>
                                    </div>

                                    <div className='w-8 h-[1px] rounded-full my-1' style={{ background: 'linear-gradient(90deg, #818cf8, #34d399)' }} />

                                    <a href={team.link}
                                        className='flex items-center gap-2 px-5 py-2 rounded-xl font-medium text-sm hover:scale-105 transition-all duration-200 mt-1'
                                        style={{ background: 'rgba(10,102,194,0.1)', border: '1px solid rgba(10,102,194,0.2)', color: '#0A66C2' }}>
                                        <FaLinkedin size={16} /> LinkedIn
                                    </a>
                                </div>
                            </div>

                            {/* Floating avatar — sits above the card */}
                            <div className='absolute left-1/2 -translate-x-1/2 top-0 z-20'>
                                <div className='relative'>
                                    <div className='absolute inset-0 rounded-full blur-xl opacity-50'
                                        style={{ background: 'radial-gradient(circle, rgba(129,140,248,0.7), rgba(52,211,153,0.4))' }} />
                                    <div className='relative rounded-full p-[3px]'
                                        style={{ background: 'linear-gradient(135deg, rgba(129,140,248,0.9), rgba(52,211,153,0.7))' }}>
                                        <img
                                            src={team.img}
                                            alt={team.name}
                                            className='w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 lg:w-40 lg:h-40 rounded-full object-cover'
                                            style={{ border: '3px solid rgba(255,255,255,0.9)' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </div>
    )
}

export default AllTeam